import { LOCALES } from 'state/intl/types';

export const polyfillListFormatLocale = async (_locale: LOCALES) => {
  // noop, browsers have wide support for list format: https://caniuse.com/?search=Intl.List
};
